$(document).ready(function () {
    $('.set-select').on('click', function (e) {
        e.preventDefault();
        var selectID = $(this).data('select-id');
        var selectValue = $(this).data('value');
        $('#'+selectID).val(selectValue).focus();
    })
});